import { useLanguage } from "../../context/LanguageContext";
import { useState, useEffect } from "react";
 
export const useTranslation = ( ) => {
  const { language } = useLanguage();
  const [translatedContent, setTranslatedContent] = useState({});
  
  useEffect(() => {
  document.body.setAttribute("data-lang", language);
  }, [language]);

  useEffect(() => {
    const loadTranslations = async () => { 
      try {
        const navMod = await import(
          `../translations/global/${language}-translations.js`
        );
        const rawNav = navMod.default || navMod;
        const nav = rawNav?.translations?.[language] || {};

        setTranslatedContent(nav);
      } catch (err) {
        const navMod = await import(
          `../translations/global/en-translations.js`
        );
        const rawNav = navMod.default || navMod;
        const nav = rawNav?.translations?.en || {};
        setTranslatedContent(nav);
      }
    };
    loadTranslations();
  }, [language]);

  //adding nested items - objects key resolver ^^
  const getNestedValue = (obj, path) => {
    if (!path || typeof path !== "string") return undefined;
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
  };

  const t = (key) => {
    const value = getNestedValue(translatedContent, key);
    return value ?? key; 
  }

  return t;
 
}

